import Vue from 'vue';
import VTooltip from 'v-tooltip';

import taskFileUpload from '@/components/task/detail/fileUpload/index.vue';

import {
  default as taskDescriptionEdit,
  default as taskDescriptionEditProofreader,
  default as taskDescriptionEditQaexpert,
} from '@/components/task/detail/descriptionEdit/index.vue';

import rating from '@/components/rating/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

import {
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  TASK_STATUS,
  JOB_STATUS,
  DEFAULT_IMAGE,
  ROLE_SYSTEM_ADMIN,
} from '@/utils/const';

Vue.use(VTooltip, {
  defaultBoundariesElement: document.body,
  defaultClass: 'my-tooltip',
});

export default {
  components: {
    taskFileUpload,
    taskDescriptionEdit,
    taskDescriptionEditProofreader,
    taskDescriptionEditQaexpert,
    rating,
  },
  mixins: [
    helpers.work_with_string,
    helpers.general,
  ],
  data () {
    return {
      statusTask: TASK_STATUS,
      userImage: DEFAULT_IMAGE,

      taskItem: null,

      roleProjectMng: ROLE_PROJECT_MNG,
      roleQaExpert: ROLE_QA_EXPERT,
      roleProofReader: ROLE_PROOF_READER,
      roleAdmin: ROLE_SYSTEM_ADMIN,

      descriptionShow: 0,
      hideTooltip: false,
      jobStatusType: {
        preparation: [],
        evaluation: [],
        validation: [],
        complete: [],
      },

      showGenDesc: false,
      showProofDesc: false,
      showQaDesc: false,

      genDescription: '',
      proofDescription: '',
      qaDescription: '',

      showFiles: false,

    };
  },
  computed: {
    taskFileUpload () {
      return this.checkPermissions('task', 'task-file-upload');
    },
    descriptionEdit () {
      return this.checkPermissions('task', 'task-description-edit');
    },
    descriptionEditProofreader () {
      return this.checkPermissions('task', 'task-description-edit-proofreader');
    },
    descriptionEditQaexpert () {
      return this.checkPermissions('task', 'task-description-edit-qaexpert');
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', true);
    this.getTaskItem(this.$route.params.id);
  },
  methods: {
    getTaskItem (id) {
      Api.tasks
        .getTaskItem(id)
        .then((data) => {
          if (data.data.Status) {
            this.taskItem = data.data.Data;
            this.taskItem.rating = {
              Rating: this.taskItem.Rating,
              KOStatus: null,
              QualityLevel: this.taskItem.QualityLevel,
            };

            this.showDescriptions();
            this.createJobsData();

            this.$store.dispatch('SHOW_PRELOADER', false);
          }
        });
    },

    refresh () {
      this.jobStatusType = {
        preparation: [],
        evaluation: [],
        validation: [],
        complete: [],
      };
      this.getTaskItem(this.$route.params.id);
    },

    showDescriptions () {
      if (this.taskItem.GenDescription !== null) {
        this.showGenDesc = 'text';

        var parseGenDescription = this.parseString(this.taskItem.GenDescription, 30);
        if (parseGenDescription != '') {
          this.genDescription = parseGenDescription;
          this.$set(this.taskItem, 'ShortGenDescription', parseGenDescription);
        }
      }

      if (this.taskItem.PRDescription !== null) {
        this.showProofDesc = 'text';

        var parseProofDescription = this.parseString(this.taskItem.PRDescription, 30);
        if (parseProofDescription != '') {
          this.proofDescription = parseProofDescription;
          this.$set(this.taskItem, 'ShortProofDescription', parseProofDescription);
        }
      }

      if (this.taskItem.QADescription !== null) {
        this.showQaDesc = 'text';

        var parseQaDescription = this.parseString(this.taskItem.QADescription, 30);
        if (parseQaDescription != '') {
          this.qaDescription = parseQaDescription;
          this.$set(this.taskItem, 'ShortQaDescription', parseQaDescription);
        }
      }
    },

    createJobsData () {
      if (this.taskItem.JobsData) {
        this.taskItem.JobsData.forEach((item) => {
          if (item.JobStatus === 'Ready') {
            this.jobStatusType.complete.push(item);
          } else {
            const status = JOB_STATUS.find((status) => status.ID === item.JobTypeID);

            if (status.Name === 'Preparation') {
              this.jobStatusType.preparation.push(item);
            }

            if (status.Name === 'Evaluation') {
              this.jobStatusType.evaluation.push(item);
            }

            if (status.Name === 'Validation') {
              this.jobStatusType.validation.push(item);
            }
          }
        });
      }
    },

    downloadFileHolder (id, name) {
      Api.tasks
        .downloadFile(id)
        .then((data) => {
          if (data.data.Status) {
            var link = document.createElement('a');
            link.style = 'display: none';
            document.body.appendChild(link);
            link.href = data.data.Data;
            link.download = name;
            link.click();
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    handleFileUpload (event) {
      const file = event.target.files[0];
      const formData = new FormData();

      if (this.taskItem) {
        formData.append('attach', file);

        Api.tasks
          .uploadFile({
            id: this.taskItem.ID,
            file: formData,
          })
          .then((data) => {
            if (data.data.Status) {
              this.$root.$emit('notification', {
                message: data.data.Message,
                type: 'info',
                show: true,
              });
              this.refresh();
            } else {
              this.$root.$emit('notification', {
                message: data.data.Message,
                type: 'error',
                show: true,
              });
            }
          });
      }
    },

    uploadTaskHolder () {
      const sendParams = {
        id: this.taskItem.ID,
        description: {
          GenDescription: this.taskItem.GenDescription,
          PRDescription: this.taskItem.PRDescription,
          QADescription: this.taskItem.QADescription,
        },
      };

      Api.tasks
        .updateTask(sendParams)
        .then((data) => {
          if (data.data.Status) {
            this.showDescriptions();
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },
  },
};
